import { usePerms } from "../../hooks/usePerms";
import { PlatformPanelsA } from "./PlatformPanelsA";
import { PlatformPanelsB } from "./PlatformPanelsB";

const GROUP_A = ["overview", "companies", "features", "requests"];

// محتوى التبويب المختار فقط، مع احترام صلاحيات عضو المنصة.
export const PlatformTabPanel = ({ tab, state, adding, setAdding, reload, sub, onSub }) => {
  const { can, isOwner } = usePerms();
  const denied =
    (tab === "revenue" && !can("billing")) ||
    (["system", "email"].includes(tab) && !can("system")) ||
    (tab === "features" && !can("companies")) ||
    (tab === "notify" && !can("companies")) ||
    (tab === "avatars" && !can("companies")) ||
    (tab === "staff" && !isOwner);

  if (denied)
    return (
      <p
        className="rounded-3xl p-8 text-center text-sm font-bold text-muted-foreground shadow-neu-in"
        data-testid="platform-tab-denied"
      >
        —
      </p>
    );

  if (GROUP_A.includes(tab))
    return (
      <PlatformPanelsA tab={tab} state={state} adding={adding} setAdding={setAdding} reload={reload} can={can} />
    );

  return <PlatformPanelsB tab={tab} state={state} sub={sub} onSub={onSub} />;
};
